<template>
    <div class="hidden">
        <vs-sidebar absolute v-model="active" open>
            <template #logo>
                <!-- ...img logo -->
            </template>
            <vs-sidebar-item id="home">

                <template #icon>
                    <i class='bx bx-home'></i>
                </template>
                Home
            </vs-sidebar-item>
            <vs-sidebar-item id="market">

                <template #icon>
                    <i class='bx bx-grid-alt'></i>
                </template>
                Market Overview
            </vs-sidebar-item>
            <vs-sidebar-item id="Music">

                <template #icon>
                    <i class='bx bxs-music'></i>
                </template>
                Music
            </vs-sidebar-item>
            <vs-sidebar-item id="donate">

                <template #icon>
                    <i class='bx bxs-donate-heart'></i>
                </template>
                Donate
            </vs-sidebar-item>
            <vs-sidebar-item id="drink">

                <template #icon>
                    <i class='bx bx-drink'></i>
                </template>
                Drink
            </vs-sidebar-item>
            <vs-sidebar-item id="shopping">

                <template #icon>
                    <i class='bx bxs-shopping-bags'></i>
                </template>
                Shopping
            </vs-sidebar-item>
            <vs-sidebar-item id="chat">

                <template #icon>
                    <i class='bx bx-chat'></i>
                </template>
                Chat
            </vs-sidebar-item>

            <template #footer>
                <vs-row justify="space-between">
                    <vs-avatar>
                        <img src="/avatars/avatar-5.png" alt="">
                    </vs-avatar>

                    <vs-avatar badge-color="danger" badge-position="top-right">
                        <i class='bx bx-bell'></i>

                        <template #badge>
                            28
                        </template>
                    </vs-avatar>
                </vs-row>
            </template>
        </vs-sidebar>
    </div>
</template>

<script>
export default {
    data: () => ({
        active: 'home',
    })
}
</script>